import { ClassConstructor } from '@nts/std/serialization';
import { NTSReflection } from '@nts/std/utility';
import { IdentityInterface, ItemViewModelInterface, ModelInterface } from '@nts/std/interfaces';

const ITEM_VIEW_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY = 'itemViewModelTypeDecoratorMetadataKey';

export function ItemViewModelTypeDecorator<TIdentity extends IdentityInterface, TModel extends ModelInterface<TIdentity>, TViewModel extends ItemViewModelInterface<TIdentity, TModel>>(itemViewModelType: ClassConstructor<TViewModel>) {
  return (target: any) => {
    if (typeof itemViewModelType?.prototype?.initItemViewModel !== 'function') {
      throw new Error(itemViewModelType + 'is not a ItemViewModel');
    }
    Reflect.defineMetadata(ITEM_VIEW_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY, itemViewModelType, target);
  };
}

export class ItemViewModelTypeInspector {
  static isApplied(subject: any): boolean {
    return NTSReflection.hasClassMetadata(
      ITEM_VIEW_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY, subject);
  }

  static getValue<T = any>(subject: any): T {
    return NTSReflection.getClassMetadata(
      ITEM_VIEW_MODEL_TYPE_META_DATA_IDENTIFICATION_KEY, subject) as T;
  }
}
